import { Component, ReactNode } from "react";

export type Props = {
  /** Fallback UI (what to render if an error occurs) */
  fallback: ReactNode;
  /** Normal content (what to try rendering) */
  children: ReactNode;
  /** Optional: Reset condition (e.g. talkjsData) to clear error state */
  resetKey?: unknown;
};

export type State = {
  hasError: boolean;
};

export class ErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error: unknown) {
    console.error("ErrorBoundary caught:", error);
  }

  componentDidUpdate(prevProps: Props) {
    if (prevProps.resetKey !== this.props.resetKey && this.state.hasError) {
      this.setState({ hasError: false });
    }
  }

  render() {
    if (this.state.hasError) {
      return this.props.fallback;
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
